// extracted by mini-css-extract-plugin
export default {"row":"ProductTourRow_row__p4ck7 font-sm-regular"};